import React, { useState } from 'react';
import { 
  Card, 
  Form, 
  Select, 
  Button, 
  Input, 
  Breadcrumb
} from 'antd';
import { 
  ReloadOutlined,
  HomeOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Option } = Select;

const SupermarketOutwardPage = ({ userdata }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // Mock data for dropdown
  const sewingLineOptions = [
    { value: 'line1', label: 'Line 1' },
    { value: 'line2', label: 'Line 2' },
    { value: 'line3', label: 'Line 3' },
    { value: 'line4', label: 'Line 4' },
  ];

  const handleNext = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      
      // Navigate to kanban plan sheet page with form data
      navigate('/kanban-plan-sheet', { 
        state: { 
          sewingLine: values.sewingLine,
          kanbanNumber: values.kanbanNumber
        }
      });
    } catch (error) {
      console.error('Form validation failed:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      padding: '0', 
      backgroundColor: 'white', 
      minHeight: '100vh',
      margin: 0
    }}>
      {/* Header Bar */}
      {/* <div style={{
        height: '50px',
        backgroundColor: 'white',
        display: 'flex',
        alignItems: 'center',
        padding: '0 16px',
        color: '#333333',
        borderBottom: '1px solid #f0f0f0'
      }}>
        <ReloadOutlined style={{ 
          fontSize: '18px', 
          marginRight: '12px',
          color: '#333333'
        }} />
        <span style={{ 
          fontSize: '16px',
          fontWeight: '500',
          color: '#333333'
        }}>
          supermarket Outward
        </span>
      </div> */}

      {/* Navigation Bar */}
      {/* <div style={{
        height: '40px',
        backgroundColor: '#f8f8f8',
        display: 'flex',
        alignItems: 'center',
        padding: '0 16px',
        borderBottom: '1px solid #e8e8e8'
      }}>
        <Breadcrumb>
          <Breadcrumb.Item>
            <HomeOutlined style={{ marginRight: '4px' }} />
            Home
          </Breadcrumb.Item>
          <Breadcrumb.Item>supermarket Outward</Breadcrumb.Item>
        </Breadcrumb>
      </div> */}

      {/* Main Content */}
      <div style={{
        padding: '40px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 'calc(100vh - 90px)'
      }}>
        {/* Pink Form Panel */}
        <Card
          style={{
            width: '400px',
            backgroundColor: '#ff69b4', // Vibrant pink/fuchsia
            border: 'none',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            marginBottom: '24px'
          }}
          bodyStyle={{
            padding: '32px'
          }}
        >
          <Form
            form={form}
            layout="vertical"
            style={{ width: '100%' }}
          >
            {/* Kanban Number */}
            <Form.Item
              label={
                <span style={{ color: 'white', fontSize: '14px', fontWeight: '500' }}>
                  Kanban Number:
                </span>
              }
              name="kanbanNumber"
              rules={[{ required: true, message: 'Please enter kanban number' }]}
              style={{ marginBottom: '24px' }}
            >
              <Input
                placeholder="Enter Kanban Number"
                style={{
                  height: '40px',
                  backgroundColor: 'white',
                  borderRadius: '4px',
                  border: '1px solid #d9d9d9'
                }}
              />
            </Form.Item>

            {/* Select Sewing Line */}
            <Form.Item
              label={
                <span style={{ color: 'white', fontSize: '14px', fontWeight: '500' }}>
                  Select Sewing Line:
                </span>
              }
              name="sewingLine"
              rules={[{ required: true, message: 'Please select a sewing line' }]}
              style={{ marginBottom: 0 }}
            >
              <Select
                placeholder="Select Line"
                style={{
                  height: '40px',
                  backgroundColor: 'white',
                  borderRadius: '4px'
                }}
                suffixIcon={<span style={{ color: '#666' }}>▼</span>}
              >
                {sewingLineOptions.map(option => (
                  <Option key={option.value} value={option.value}>
                    {option.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Form>
        </Card>

        {/* External Next Button */}
        <Button
          type="default"
          onClick={handleNext}
          loading={loading}
          style={{
            width: '400px',
            height: '45px',
            backgroundColor: 'white',
            border: '1px solid #666666',
            borderRadius: '4px',
            fontSize: '16px',
            fontWeight: '500',
            color: '#333333',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#f5f5f5';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'white';
          }}
        >
          &lt;&lt;&lt;&lt;&lt; Next &gt;&gt;&gt;&gt;&gt;
        </Button>
      </div>
    </div>
  );
};

export default SupermarketOutwardPage;


